<div class="input-group">
  <ng-content/>
  <button class="input-group-text border-0" [ngClass]="btnClasses ? btnClasses : defaultClasses" (click)="openQrModal(qrModal)" [style]="{'width': btnPxWidth || '50px'}" type="button">
    <i class="fa-solid fa-qrcode"></i>
  </button>
</div>

<ng-template #qrModal>
  <div class="modal-header border-0">
    <button type="button" class="btn-close shadow-none" aria-label="Close" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <!-- <h4 class="modal-title text-center mb-4" >{{'QR.export.title' | transloco}}</h4> -->

    @if (qrText) {
      <qrcode class="text-center" [qrdata]="qrText" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
    }

    <div class="text-center my-2"><b>{{qrText}}</b></div>

  </div>
  <!-- <div class="modal-footer justify-content-center border-0">
  <button type="button" class="btn btn-outline-dark footer-btn " (click)="closeModal()">
    {{'GENERIC.texts.close' | transloco}}
    <i class="fa-solid fa-xmark"></i>
  </button>
</div> -->
</ng-template>

